import { render } from "./PostcardDetails.vue?vue&type=template&id=5cdf7e62&scoped=true"
import script from "./PostcardDetails.vue?vue&type=script&lang=js"
export * from "./PostcardDetails.vue?vue&type=script&lang=js"

import "./PostcardDetails.vue?vue&type=style&index=0&id=5cdf7e62&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdf7e62"]])

export default __exports__